// -----------------------------------------------------------------------------
// PLUGINS/LINK
// -----------------------------------------------------------------------------
import { TextSelection } from "prosemirror-state";
import icons from "../util/icons";
import { elt, input, setClass, calcModulePosition_ } from "../util/dom";
import { markActive } from "../util/selection";
export class Link {
    constructor(view, container, markType, key) {
        this.view = view;
        this.mark = markType;
        this.key = key;
        this.range = null;
        this.linking = false;
        this.focused = false;
        this.container = container;
        // console.log("Link", container)
        this.field = input("text", "df-ed-pp__field");
        // The mini panel
        this.miniPointer = icons.pointer("df-ed-mi__pointer");
        this.mini = elt("div", {
            className: "df-ed-mi"
        }, this.miniPointer, elt("div", {
            className: "df-ed-mi__container"
        }, elt("div", {
            className: "df-ed-mi__button df-ed-mi__button--open",
            onclick: () => { this.openPanel(); }
        }, icons.edit("df-ed-mi__icon")), elt("div", {
            className: "df-ed-mi__button df-ed-mi__button--remove",
            onclick: () => { this.remove(false); }
        }, icons.unlink("df-ed-mi__icon")), elt("div", {
            className: "df-ed-mi__button",
            onclick: () => {
                window.open(this.range.mark.attrs.href, "_blank");
            }
        }, icons.externalLink("df-ed-mi__icon"))));
        view.dom.parentNode.insertBefore(this.mini, view.dom);
        // The main editing panel
        this.panelPointer =
            icons.pointer("df-ed-pp__pointer");
        this.panel = elt("div", {
            className: "df-ed-pp"
        }, this.panelPointer, elt("div", {
            className: "df-ed-pp__container"
        }, elt("div", {
            className: "df-ed-pp__fields"
        }, elt("label", { className: "df-ed-pp__fieldgroup" }, "URL", this.field)), elt("div", {
            className: "df-ed-pp__buttons"
        }, elt("span", {
            className: "df-ed-pp__button",
            onclick: () => this.commit()
        }, icons.chevronRight("df-ed-pp__icon")), elt("span", {
            className: "df-ed-pp__button",
            onclick: () => this.remove(true)
        }, icons.unlink("df-ed-pp__icon")))));
        view.dom.parentNode.insertBefore(this.panel, view.dom);
        // The menu button
        this.dom = elt("div", {
            className: "df-ed-mu__item df-ed-mu__item--clickable",
            onclick: () => { this.openPanel(); }
        }, icons.link("df-ed-mu__icon"));
        // General events
        window.addEventListener("mousedown", (event) => {
            let active = this.key.getState(this.view.state).module;
            let target = event.target;
            if (target instanceof Element) {
                if (!this.panel.contains(target) && !this.view.dom.contains(target)) {
                    this.focused = false;
                    if (active === "link-module") {
                        if (this.range && this.range.mark && this.range.mark.attrs.href === "") {
                            this.remove(true);
                        }
                        this.closeModules();
                    }
                }
                else {
                    this.focused = true;
                }
                if (!this.mini.contains(target) && !this.view.dom.contains(target)) {
                    this.focused = false;
                    if (active === "link-mini")
                        this.closeModules();
                }
                else {
                    this.focused = true;
                }
            }
        });
        window.addEventListener("keydown", (event) => {
            let active = this.key.getState(this.view.state).module;
            if (active === "link-module") {
                if (event.key === "Enter") {
                    event.preventDefault();
                    this.commit();
                    this.closeModules();
                }
                if (event.key === "Escape") {
                    event.preventDefault();
                    this.closeModules();
                }
            }
        });
        window.addEventListener("resize", () => {
            let active = this.key.getState(this.view.state).module;
            let { from, to } = this.view.state.selection;
            if (active === "link-mini")
                this.positionMini();
            if (active === "link-module")
                this.positionPopup(from, to);
        });
    }
    positionMini() {
        let { start, end } = this.range;
        let { x, y } = calcModulePosition_(this.view, this.container.panel, start, end, this.mini.getBoundingClientRect().width / 2);
        this.mini.style.top = y;
        this.mini.style.marginLeft = x;
    }
    positionPopup(start, end) {
        let { x, y } = calcModulePosition_(this.view, this.container.panel, start, end, 15);
        this.panel.style.top = y;
        this.panelPointer.style.left = x;
    }
    commit() {
        let { $from, $to } = this.view.state.selection, tr = this.view.state.tr;
        if (this.field.value !== "") {
            tr.addMark($from.pos, $to.pos, this.mark.create({ href: this.field.value }));
        }
        else {
            tr.removeMark($from.pos, $to.pos, this.mark);
        }
        this.linking = false;
        tr.setMeta(this.key, "link-mini");
        this.view.dispatch(tr.scrollIntoView());
    }
    remove(viaPanel) {
        if (viaPanel) {
            let { $from, $to } = this.view.state.selection;
            this.view.dispatch(this.view.state.tr.removeMark($from.pos, $to.pos, this.mark));
            this.closeModules();
        }
        else {
            let { start, end } = this.range;
            this.view.dispatch(this.view.state.tr.removeMark(start, end, this.mark));
            this.closeModules();
        }
    }
    openMini() {
        const tr = this.view.state.tr;
        tr.setMeta(this.key, "link-mini");
        this.view.dispatch(tr);
    }
    openPanel() {
        const tr = this.view.state.tr, { from, to } = this.view.state.selection;
        const range = getLinkRange(this.view.state, from, to, this.mark);
        if (range) {
            let { start, end, mark } = range;
            this.positionPopup(start, end);
            this.field.value = mark.attrs.href;
            tr.setSelection(TextSelection.create(this.view.state.doc, start, end));
        }
        else {
            this.range = { start: from, end: to, mark: this.mark.create() };
            tr.addMark(from, to, this.mark.create({ href: "" }));
            this.positionPopup(from, to);
            this.field.value = "";
        }
        tr.setMeta(this.key, "link-module");
        tr.scrollIntoView();
        this.view.dispatch(tr);
        this.field.focus();
    }
    closeModules(transaction) {
        let tr = transaction || this.view.state.tr;
        this.linking = false;
        tr.setMeta(this.key, "close-module");
        this.view.dispatch(tr);
        this.view.focus();
    }
    update() {
        let { $from, from, to } = this.view.state.selection, disable = false, active = this.key.getState(this.view.state).module, range = getLinkRange(this.view.state, from, to, this.mark), inrange = range && from >= range.start && to <= range.end;
        if (this.view.state.selection instanceof TextSelection) {
            disable =
                this.view.state.selection.$cursor && !this.mark.isInSet($from.marks());
        }
        if (this.range && !inrange && !this.linking) {
            let tr = this.view.state.tr;
            if (this.range.mark && this.range.mark.attrs.href === "") {
                tr.removeMark(this.range.start, this.range.end, this.mark);
            }
            this.range = null;
            this.closeModules(tr);
            return;
        }
        if (active === "link-module" && this.range && range && this.range.start !== range.start) {
            this.closeModules();
            return;
        }
        if (this.range === null && inrange && !this.linking) {
            let { start, end } = range;
            this.range = range;
            this.openMini();
            this.positionMini();
            return;
        }
        if (inrange && !this.linking) {
            this.range = range;
            if (active !== "link-mini" && active !== "link-module" && this.focused) {
                this.openMini();
                this.positionMini();
                return;
            }
            this.positionMini();
        }
        if (this.range && range === null) {
            this.range = null;
            this.closeModules();
            return;
        }
        this.linking = false;
        setClass(this.dom, "df-ed-mu__item--disabled", disable);
        setClass(this.mini, "df-ed-mi--active", active === "link-mini");
        setClass(this.panel, "df-ed-pp--active", active === "link-module");
    }
    active(state) {
        return markActive(this.mark)(state);
    }
    destroy() {
        this.mini.remove();
        this.panel.remove();
    }
}
function getLinkRange(state, from, to, markType) {
    let doc = state.doc;
    let start = null;
    let end = null;
    let lookforward = false;
    let lookbackward = false;
    let i = from;
    let mark = null;
    // For selections that aren't ranges;
    to = from === to ? to + 1 : to;
    // First do a general check to see if it's even worth doing a more
    // Note that this tends to blow up when the gap cursor plugin is enabled.
    if (!doc.rangeHasMark(from, to, markType)) {
        return null;
    }
    while (i <= to) {
        if (start === null && doc.rangeHasMark(i, i + 1, markType)) {
            if (i === from)
                lookbackward = true;
            mark =
                markType.isInSet(doc.resolve(i + 1).marks()) ||
                    markType.isInSet(doc.resolve(i).marks());
            start = i;
            i++;
        }
        else if (start !== null && !doc.rangeHasMark(i, i + 1, markType)) {
            end = i;
            break;
        }
        else if (start !== null && i == to) {
            end = i;
            lookforward = true;
            break;
        }
        else {
            i++;
        }
    }
    if (start === null && end === null)
        return null;
    if (lookbackward) {
        while (doc.rangeHasMark(start - 1, start, markType))
            start--;
    }
    if (lookforward) {
        while (doc.rangeHasMark(end, end + 1, markType))
            end++;
    }
    if (mark) {
        return { start, end, mark };
    }
    else {
        return null;
    }
}
